module.exports = __webpack_public_path__ + "static/media/brand-refresh-TiktokLogo.77e39184.svg";